import "./LoadingIndicator.css";

export function LoadingIndicator() {
  return (
    <div className="camera-container">
      <span className="camera-base">📷</span>
      <span className="camera-flash">📸</span>
    </div>
  );
}
